import { Page } from '@/components/layout/page/page.tsx'
import { AutomationSettings } from '@/modules/automation-settings/components/automation-settings.tsx'

export const AutomationSettingsView = () => {
  return (
    <Page
      title="Automation Settings"
      description="Select when your automation features should be running. If a member is online, the features will be running regardless."
    >
      <hr />
      <AutomationSettings />
    </Page>
  )
}
